export const PURPOSE = {
    REGISTER: "register",
    RESET_PASSWORD: "password_reset"
}